// import React, { useEffect, useState } from "react";
// import { Card, Row, Col, Radio } from "antd";
// import { Modal, Button, Input, Form } from "antd";
// import ReactECharts from "echarts-for-react";
// import { APIConstants } from "../../../Common/APIConstants";
// import { adjustTimeByFiveHoursThirtyMinutes } from "../../../Utils/DateConverstion";
// import { useStoreUpdaterWithAPI } from "../../../Hooks/UseStoreUpdaterWithApi";
// import dayjs from "dayjs";
// import { getAdjustedDate } from "../CommonFunctions";
import FoudaryChart from "../hocs/FoudaryChart";
import SMMLSECBarChart from "../hocs/SMMLSECBarChart";
import SMMLDonutConsumption from "../hocs/SMMLDonutConsumption";
import SMMILSECStatistics from "../hocs/SMMILSECStatistics";

// const SensorFour = (props) => {

//     const theme = props.theme 
//     console.log(theme)
//     const isDark = theme === "dark";
//     const textColor = isDark ? "#ffffff" : "#000000";
//     const backgroundColor = isDark ? "#151236" : "#ffffff";
//     const borderColor = isDark ? "#333" : "#ddd";
  
//     // Card Styling
//     const cardStyle = {
//       backgroundColor,
//       color: textColor,
//       border: `1px solid ${borderColor}`,
//     };
//   const gaugeOption =  {
//     series: [
//       {
//         type: 'gauge',
//         startAngle: 180,
//         endAngle: 0,
//         center: ['50%', '60%'],
//         radius: '90%',
//         min: 0,
//         max: 1,
//         splitNumber: 8,
//         axisLine: {
//           lineStyle: {
//             width: 6,
//             color: [
//               [0.25, '#FF6E76'],
//               [0.5, '#FDDD60'],
//               [0.75, '#58D9F9'],
//               [1, '#7CFFB2']
//             ]
//           }
//         },
//         pointer: {
//           icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
//           length: '12%',
//           width: 20,
//           offsetCenter: [0, '-60%'],
//           itemStyle: {
//             color: 'auto'
//           }
//         },
//         axisTick: {
//           length: 12,
//           lineStyle: {
//             color: 'auto',
//             width: 2
//           }
//         },
//         splitLine: {
//           length: 20,
//           lineStyle: {
//             color: 'auto',
//             width: 5
//           }
//         },
//         axisLabel: {
//           color: '#464646',
//           fontSize: 20,
//           distance: -60,
//           rotate: 'tangential',
//           formatter: function (value) {
//             if (value === 0.875) {
//               return 'Grade A';
//             } else if (value === 0.625) {
//               return 'Grade B';
//             } else if (value === 0.375) {
//               return 'Grade C';
//             } else if (value === 0.125) {
//               return 'Grade D';
//             }
//             return '';
//           }
//         },
//         title: {
//           offsetCenter: [0, '-10%'],
//           fontSize: 20
//         },
//         detail: {
//           fontSize: 30,
//           offsetCenter: [0, '-35%'],
//           valueAnimation: true,
//           formatter: function (value) {
//             return Math.round(value * 100) + '';
//           },
//           color: 'inherit'
//         },
//         data: [
//           {
//             value: 0.7,
//             name: 'Grade Rating'
//           }
//         ]
//       }
//     ]
//   };

//   const barOption = {
//     legend: {
//       top: "top", // Places legend at the top
//     },
//     xAxis: {
//       type: "category",
//       data: ["SMMIL Plant", "Unit-1", "Unit-2", "Investment"],
//     },
//     yAxis: { type: "value" },
//     series: [
//       { name: "Target", type: "bar", data: [320, 332, 301, 334] },
//       { name: "YTD Actual", type: "bar", data: [150, 182, 191, 234] },
//     ],
//   };
  

//   const pieOption = {
//     series: [
//       {
//         type: "pie",
//         data: [
//           { value: 1048, name: "Wind" },
//           { value: 735, name: "Solar" },
//           { value: 580, name: "IDK-560" },
//         ],
//         label: {
//           show: true, // Show values by default
//           formatter: "{b}: {c}", // Display name (b) and value (c)
//         },
//         emphasis: {
//           label: {
//             show: true, // Show values on hover
//             fontSize: "16",
//             fontWeight: "bold",
//           },
//         },
//       },
//     ],
//   };
  
  

//   const data = [
//     { label: 'PF', value: '0.98' },
//     { label: 'V THD', value: '2.0%' },
//     { label: 'I THD', value: '9.0%' },
//     { label: 'Voltage', value: '33,000.0' },
//     { label: 'Current', value: '25.0' },
//     { label: 'kW', value: '4,250' }
//   ];

//   const labels = [

//     "IEXGDAM",
//     "IEXDAMAndRTM",
//     "Wind",
//     "Solar",
//     "SandUnitOne",
//     "SandUnitTwo",
//     "Investment",
//     "SKOSand",
//     "SKOInvestment",
//     "HSDSand",
//     "HSDInvestment",
//     "LPGSand",
//     "CreatedOn",
//   ];


//   const [form] = Form.useForm();
//   const [selected, setSelected] = useState("Sand Unit-1");
//   return (
//     <div style={{ padding: 20 }} className="w-full flex-col ">
     
//       <FoudaryChart cardStyle={cardStyle} theme={theme}  />
//       <div className="flex w-[100%] gap-3  mb-4 ">
//         <SMMLSECBarChart theme={theme} cardStyle={cardStyle} />
//         <SMMLDonutConsumption theme={theme} cardStyle={cardStyle} /> 

//       </div>

//       <SMMILSECStatistics  />

//     </div>
//   );
// };

// export default SensorFour;


import React, { useState } from 'react';
import { Select } from 'antd';
import { useSelector } from "react-redux";

const { Option } = Select;

const SensorFour = ({ theme, cardStyle }) => {
  const [selectedDashboard, setSelectedDashboard] = useState('dashboard1');
  console.log(theme)
  const isdarkMode = theme === 'dark';

  return (
    <div className="p-4 text-right ">
      {/* Ant Design Select Dropdown */}
      <Select
        value={selectedDashboard}
        onChange={setSelectedDashboard}
        // className="w-[300px] mb-4 text-left "
        className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 mb-4 text-left `}
                dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
        size="large"
      >
        <Option value="dashboard1">SMML Summary</Option>
        <Option value="dashboard2">Unit Summary</Option>
      </Select>

      {/* Conditional Rendering Based on Selection */}
      {selectedDashboard === 'dashboard1' ? (
        <>
        <FoudaryChart cardStyle={cardStyle} theme={theme}  />
         <div className="flex w-[100%] gap-3  mb-4 ">
          <SMMLSECBarChart theme={theme} cardStyle={cardStyle} />
          <SMMLDonutConsumption theme={theme} cardStyle={cardStyle} />
         </div>
        </>
      ) : ( 
        <SMMILSECStatistics />
      )}
    </div>
  );
};

export default SensorFour;
